import React from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import { Link } from "react-router-dom";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";

import { useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import API from "../../services/api";


const CatalogAlbum = (props) => {
  
  const ref = useRef(null);
  
  const {catalogId}=useParams();
  const location = useLocation();
  const { catalogData } = location.state || {};

  useEffect(()=> {
    // console.log("catalog data : ", catalogData)
    if(!catalogData?.ID || !catalogId)
      toast(({ closeToast }) => <ErrorToast message={"Catalog reference missing."} />);
  },[])
  
  const [loading, setLoading] = useState(true);
  const [albumList, setAlbumList] = useState([]);
  

  useEffect(() => {
      (async() => {
        await loadCatalogAlbumList()
      })()
    
  }, [])

  const loadCatalogAlbumList = async() => {
    setLoading(true);
    await API.loadCatalogAlbums(catalogId).then((resp) => {
      // console.log("Albums : ", resp);
      setAlbumList(resp.data.Albums);
    }).catch((err) => {
      console.log("Catalog Albums Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Catalog Album list loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }

  return (
    
    <div className="px-4 sm:px-8 md:px-8 lg:px-8 items-center flex-1  pt-3 sm:mx-4 mx-4 lg:mx-20 playlist">
      
    {(catalogData && 
      <div className="pb-3 mt-8 md:mt-0">
        <div className="flex flex-col md:flex-row">
          <div className="w-full lg:w-3/12 rounded-md mb-4 lg:mb-0">
            <div className="image-container max-w-xs mx-auto md:mt-0 mt-12 lg:mx-0">
              {catalogData?.LibraryLogoUrl ? (
                <img
                  src={catalogData?.LibraryLogoUrl || defaultImage}
                  alt=""
                  onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                  className="w-full border rounded-2xl"
                  loading="lazy"
                />
              ) : (
                <img
                  src={defaultImage}
                  alt="Catalog img"
                  className="w-full border-b music-image justify-center align-middle"
                  loading="lazy"
                />
              )}
            </div>
          </div>
          <div className="w-full lg:w-8/12 lg:pl-5">
            <h1 className="mb-2 text-xl text-center md:text-left">{catalogData?.Name}</h1>
            {catalogData?.Detail?.length > 0 && 
            <p className="w-full lg:w-3/5 text-justify text-description text-sm sm:text-base">
              {catalogData?.Detail}
            </p>}
          </div>
        </div>
      </div>
    )}
    
    <div className="border-t my-2"></div>
    
    <div className="w-full">
      {loading && (
        <div className="w-full">
          <BouncingLoader />
        </div>
      )}
      {!loading && !(albumList?.length > 0) ? (
        <div className="text-lg sm:text-xl text-center text-red-500 my-5">
          No Album Found
        </div>
      ) : (
        <div className="bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mt-4 sm:mt-6 md:mt-12">
          {albumList?.map((elem, index) => (
            <Link to={`/album/${elem?.ID}`} key={elem?.ID}>
              <div className="music-tile">
                <div className="image-container relative">
                  {Helper.getArtworkURL(elem?.ID)?.length > 0? (
                    <img
                      src={Helper.getArtworkURL(elem?.ID) || defaultImage}
                      alt="Album img"
                      onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                      className="w-full border rounded-xl sm:rounded-2xl cursor-pointer object-cover aspect-square"
                      loading="lazy"
                    />
                  ) : (
                    <img
                      src={defaultImage}
                      alt="Album img"
                      className="w-full border-b cursor-pointer music-image justify-center align-middle object-cover aspect-square"
                      loading="lazy"
                    />
                  )}
                  <span className="play_icon absolute" title="Play"></span>
                </div>
                <div className="p-2">
                  <p className="text-sm font-bold line-clamp-1">{elem?.DisplayTitle || elem?.Name}</p>
                  {elem.Detail?.length > 0 &&
                    <p className="text-xs sm:text-sm font-light text-left description line-clamp-2"
                      title={elem?.Detail}
                    >
                      {elem?.Detail || elem?.DisplayTitle || elem?.Name}
                    </p>
                  }
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
      
    </div>
  </div>
  );
};

export default CatalogAlbum;